// services/notificationService.js
import api from './api';

/**
 * Сервис для работы с уведомлениями
 */
const notificationService = {
  /**
   * Получение непрочитанных уведомлений для текущего пользователя
   * @returns {Promise<Array>} - Массив непрочитанных уведомлений
   */
  getUnreadNotifications: async () => {
    try {
      const response = await api.get('/notifications/unread');
      return response.data || [];
    } catch (error) {
      console.error('Ошибка при получении непрочитанных уведомлений:', error);
      // Возвращаем пустой массив в случае ошибки, чтобы не блокировать работу приложения
      return [];
    }
  },

  /**
   * Отметка уведомления как прочитанного
   * @param {string} notificationId - ID уведомления
   * @returns {Promise<void>}
   */
  markAsRead: async (notificationId) => {
    try {
      await api.post(`/notifications/${notificationId}/read`);
    } catch (error) {
      console.error('Ошибка при отметке уведомления как прочитанного:', error);
      throw error;
    }
  }
};

export default notificationService;

